exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (max-width:1088px){.header-logo-container[data-v-6a62df60]{display:flex;flex-direction:column;align-items:center;justify-content:center;height:63px}.header-logo-container img[data-v-6a62df60]{max-height:36px;max-width:36px}.header-logo-container.wide-logo img[data-v-6a62df60]{width:33vw;max-width:160px;-o-object-fit:contain;object-fit:contain}.header-logo-container .header-location[data-v-6a62df60]{padding-top:4px;margin-bottom:-4px;font-size:.8em;font-weight:700;color:#ec1c24;min-height:1.6em}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6a62df60","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/header/NavigationItems/HeaderLogoLocation.vue
// module id = p/38
// module chunks = 18